<div
  *ngIf="alert"
  [@close]="!isAlertOpen ? 'closed' : 'open'"
  class="alert mt-3 bg-{{ alert!.type }}"
>
  <div class="alert-content">
    <ng-container [ngSwitch]="alert!.type">
      <span>
        <i *ngSwitchCase="alertTypes.Error" class="icon-exclamation" aria-hidden="true"></i>
        <i *ngSwitchCase="alertTypes.Warning" class="icon-exclamation" aria-hidden="true"></i>
        <i *ngSwitchCase="alertTypes.Success" class="icon-success" aria-hidden="true"></i>
        <i *ngSwitchCase="alertTypes.Info" class="icon-info-2" aria-hidden="true"></i>
      </span>
    </ng-container>

    <span [innerHTML]="alert.message | sanitizeHtml"></span>
  </div>

  <button
    (click)="forceClose()"
    class="close ml-2"
    type="button"
  >
    <i class="icon-cancel-alt" aria-hidden="true"></i>
  </button>
</div>
